import React from 'react';
import 'bootstrap/dist/js/bootstrap.min';
import GuideEntryContainer from "../GuideEntryContainer";
import '../static/styles/apiguide.scss'
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";

export default class HMacSignatureContent extends React.Component {
    static pathToHTML = require.context('static/content', true);
    static HTML_PREFIX = "./";

    constructor(props){
        super(props);
    }

    renderHTML(fileName) {
        return (
            <div dangerouslySetInnerHTML={{__html: GuideEntryContainer.pathToHTML(fileName, true)}}></div>
        );
    }

    render() {
        return(
        <div className = "col-sm-12">
            <div className="section-02 page-header" id="guides-section-02">
                <h1 className="blog-title">HMAC Signature 생성</h1>
            </div>
            <div className="blog-post">
                <h3 className="mt40">HMAC이 무엇이고 왜 필요한가요?</h3>
                <p>
                    HMAC은 해시 메시지 인증코드(keyed-hash message authentication code)의 준말로써 RFC2014 표준 암호화 프로토콜입니다.
                    현재 Coupang Open API는 HMAC기반으로 제작되었으며 모든 request header 'Authorization'에 생성한 HMAC signature를
                    함께 보내주셔야 합니다.
                </p>
            </div>
            <div className="blog-post">
                <h3 className="mt40">HMAC Signature 생성+API 요청 예제</h3>
                { /* [s]0904_수정 */}
                <Tabs>
                    <TabList>
                        <Tab>Java</Tab>
                        <Tab>PHP</Tab>
                        <Tab>Python</Tab>
                        <Tab>C#</Tab>
                    </TabList>

                    <TabPanel>
                        <h4 className="mt40">Java HMAC Signature Generate Example</h4>
                        <p>
                            <a download="" href="https://img2a.coupangcdn.com/files/hmac_sdk.zip?v=2">
                                <button md-raised-button="" className="mat-raised-button">
                                    <span className="mat-button-wrapper">Java HMAC Generator Download</span>
                                    <div className="mat-button-ripple mat-ripple" md-ripple=""></div>
                                    <div className="mat-button-focus-overlay"></div>
                                </button>
                            </a>
                        </p>
                        <div className="position-releative">
                            {this.renderHTML('./guides/HMAC_Signature_java.html')}
                        </div>
                    </TabPanel>

                    <TabPanel>
                        <h4 className="mt40">PHP HMAC Signature Generate Example</h4>
                        <div className="position-releative">
                            {this.renderHTML('./guides/HMAC_Signature_PHP.html')}
                        </div>
                    </TabPanel>


                    <TabPanel>
                        <h4 className="mt40">Python HMAC Signature Generate Example</h4>
                        <div className="position-releative">
                            {this.renderHTML('./guides/HMAC_Signature_Python.html')}
                        </div>
                    </TabPanel>

                    <TabPanel>
                        <h4 className="mt40">C# HMAC Signature Generate Example</h4>
                        <div className="position-releative">
                            {this.renderHTML('./guides/HMAC_Signature_C.html')}
                        </div>
                    </TabPanel>
                </Tabs>
            </div>
        </div>
    );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/HMacSignatureContent.jsx